module.exports = __webpack_public_path__ + "img/hero-desktop.74376dd3.webp";